import { getHousesForStreet } from '@fttb/common/store';
import { emptyArr } from '@beef/utils';
import { POPUP_CONNECTION_STATE } from "../../../../store/common/constants";
export var useFetchHouse = function useFetchHouse(_ref) {
  var setChosenHouse = _ref.setChosenHouse,
    street = _ref.street,
    setAddressChecked = _ref.setAddressChecked;
  var fetchHouses = function fetchHouses(value) {
    return getHousesForStreet(street.id, value).then(function (_ref2) {
      var data = _ref2.data;
      if ((data === null || data === void 0 ? void 0 : data.length) === 0 || !Array.isArray(data)) {
        setAddressChecked(POPUP_CONNECTION_STATE.houseIsNotFound);
        return emptyArr;
      }
      return data;
    });
  };
  var onSelectHouseFromList = function onSelectHouseFromList(value) {
    var statusConnection = !value.isConnected ? POPUP_CONNECTION_STATE.isNotAvailable : POPUP_CONNECTION_STATE.isNone;
    setAddressChecked(statusConnection);
    setChosenHouse(value);
  };
  return {
    fetchHouses: fetchHouses,
    onSelectHouseFromList: onSelectHouseFromList
  };
};